import {Component, Input, ViewChild} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs';
import {AnalyticsService} from '../analytics.service';
import {ApiService, HttpError} from '../api.service';
import {AuthService} from '../auth.service';
import {ModalComponent} from '../modal/modal.component';

const SUCCESS_MODAL_TIMEOUT = 4000;

@Component({
  selector: 'feedback-modal',
  templateUrl: './feedback-modal.component.html',
  styleUrls: ['./feedback-modal.component.scss']
})
export class FeedbackModalComponent {

  @Input() subheading: string;

  @ViewChild('modal') modal: ModalComponent;
  @ViewChild('successModal') successModal: ModalComponent;

  feedbackText: string | null = null;
  error: string | null = null;
  masquerading$ = this.Auth.masquerading$;

  constructor(private Api: ApiService,
              private Auth: AuthService,
              private Analytics: AnalyticsService) {
  }

  show() {
    this.modal.show();
  }

  hide(): void {
    this.modal.hide();
  }

  onHide() {
    this.feedbackText = null;
  }

  submit() {
    if (this.masquerading$.getValue()) {
      return;
    }
    this.error = null;
    if (this.feedbackText) {
      this.Api.sendFeedback(this.feedbackText)
        .pipe(catchError((err: HttpError) => {
          this.error = (err && err.code) || '';
          return of(null);
        }))
        .subscribe(() => {
          this.modal.hide();
          this.successModal.show();
          window.setTimeout(() => this.successModal.hide(), SUCCESS_MODAL_TIMEOUT);
        });
      this.Analytics.trackEvent('Feedback' +
        (this.subheading ? (' ' + this.subheading.charAt(0).toUpperCase() + this.subheading.slice(1)) : ''));
    }
  }
}
